module.exports = __webpack_public_path__ + "static/media/Report.88d31b1d.svg";